import React,{Component} from 'react';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterListIcon from '@mui/icons-material/FilterList';
import { lighten } from '@mui/system/colorManipulator';
import SelectionAlert from './SelectionAlert';
import {createActions,filterActions} from './GridActions';
import { Box, type Theme } from '@mui/material';

const s:any = {
  root: {
    paddingRight: 'spacing(1)',
  },
  highlight: (theme: Theme) => ({
          color: 'secondary.main',
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }),
  spacer: {
    flex: '1 1 100%',
  },
  actionlist: {
    display: 'flex'
  },
  actions: {
    display: 'flex',
    color: 'text.secondary',
  },
  title: {
    flex: '0 0 auto',
  },
};

class GridToolbar extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode:0,
      opencs:false,
      openfb: false
    };
  }

  openSelector = (ev:any) => this.setState({opencs:true});
  closeSelector = (ev:any) => this.setState({opencs:false});
  openFilter = (ev:any) => this.setState({openfb:true});
  closeFilter = (ev:any) => this.setState({openfb:false});
  
  render() {
    //console.log('in GridToolbar.render()');
    const { title, sdata, actions, numSelected, selectedRecord, rowCount, cols, fcols, setColumns,handleSelect, onAction, refresh } = this.props;
    const { filterOpen, onToggleFilter } = this.props;
    const { openfb } = this.state;

    const newrecord = { item: { sts: 1, a: 'add' }, action: 'add' };
    
    //const news = [{action:'add',label:'New',title:'New',icon:<NewIcon/>},...(createActions(actions))]; 
    const news = createActions(actions);
    const menu = filterActions(actions);
    //console.log('newmenus',news,actions);
    //[{action:'edit',label:'Edit',title:'Edit'},{action:'view',label:'View',title:'View'},{action:'delete',label:'Delete',title:'Delete'}];
    
    
    return (
      <Toolbar
        // sx={{...s.root, ...(numSelected > 0?s.highlight:{})}}
        sx={{
          px: 2,
          py: 1.25,
          minHeight: 'unset',
          borderBottom: '1px solid #E2E8EE',
          backgroundColor: '#FFFFFF',
        }}
      >
        <Box sx={{...s.title}}>
          {/* title */}
          <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#17324D', lineHeight: 1.2, }}>
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              color: '#66788A',
              mt: 0.25,
            }}
          >
            {/* {sdata?.length || 0} records */}
            {rowCount || 0} records
          </Typography>
        </Box>
        <Box sx={{...s.spacer}} />
        {/* the static prefix actions (new, wizard) */}
        <Box sx={{...s.actions}}>
          {news.map((mi:any)=>(
            <React.Fragment key={mi.action}>
              <Tooltip title={mi.title} placement="top">
                <IconButton 
                  size="small"
                  sx={{
                    borderRadius: '8px',
                    color: '#4B5C6C',
                    '&:hover': { backgroundColor: '#F3F7F9' },
                  }}
                  aria-label={mi.label} 
                  onClick={handleSelect({item:{sts:1,a:mi.action},action:mi.action})}
                >
                  {mi.icon}
                </IconButton>
              </Tooltip>
            </React.Fragment>
          ))}
        </Box>
        {/* selected badge */}
        <Box sx={{...s.title}}>
          <SelectionAlert numSelected={numSelected}/>
        </Box>
        {/* selected mode actions */}
        {(numSelected > 0) && (
        <Box sx={{...s.actions}}>
          {menu.map((mi:any)=>(
            <React.Fragment key={mi.action}>
              <Tooltip title={mi.title} placement="top">
                <IconButton 
                  size="small"
                  sx={{
                    borderRadius: '8px',
                    color: '#4B5C6C',
                    '&:hover': { backgroundColor: '#F3F7F9' },
                  }}
                  aria-label={mi.label} 
                  onClick={handleSelect({item:selectedRecord,action:mi.action})}
                >
                  {mi.icon}
                </IconButton>
              </Tooltip>
            </React.Fragment>
          ))}
          
        </Box>
        )}
        {/* static suffix actions */}
        <Box sx={{...s.actions}}>
            <Tooltip title={filterOpen ? "Hide filters" : "Show filters"} placement="top">
              <IconButton
                size="small"
                sx={{
                  borderRadius: '8px',
                  color: '#4B5C6C',
                  '&:hover': { backgroundColor: '#F3F7F9' },
                }}
                onClick={onToggleFilter}
              >
                <FilterListIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Refresh" placement="top">
              <IconButton 
                size="small"
                sx={{
                  borderRadius: '8px',
                  color: '#4B5C6C',
                  '&:hover': { backgroundColor: '#F3F7F9' },
                }}
                aria-label="Refresh Grid" 
                onClick={() => refresh?.()}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            {/* <GridFilter open={openfb} sdata={sdata} onClose={this.closeFilter} cols={cols} fcols={fcols} setColumns={setColumns} refresh={refresh}/> */}
          </Box>
      </Toolbar>
    );
  }
}

export default GridToolbar;
